import React from "react";
import { BOOKING_STATUS } from "utils/constant";
import cx from "classnames";
import { Badge as AntdBadge } from "antd";
import renderPropsComposer from "utils/renderPropsComposer";
interface BadgeProps {
  children?: React.ReactNode;
  label?: string;
  status?: "success" | "processing" | "error" | "default" | "warning";
  type?:
    | "filter"
    | "antd"
    | "discount"
    | "waiting"
    | "done"
    | "user_cancelled"
    | "shop_cancelled"
    | "not_show"
    | "accepted";
  isActive?: boolean;
  onClick?: () => void;
  dot?: boolean;
  [key: string]: any;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  label = "",
  status = "default",
  type,
  isActive = false,
  dot = false,
  className = "",
  ...props
}) => {
  const getTypeClasses = () => {
    switch(type) {
      case "waiting": return "bg-waiting text-black-01";
      case "done": return "bg-done text-white";
      case "accepted": return "bg-primary text-white";
      case "user_cancelled":
      case "shop_cancelled": return "bg-danger text-white";
      case "not_show": return "bg-cancel text-white";
      case "filter": return null; // Handle filter separately
      case "discount": return "absolute top-0 right-0 p-1 px-2 z-10 rounded-none rounded-tr-2xl rounded-bl-2xl bg-danger text-white";
      default: return "text-white";
    }
  };

  return renderPropsComposer(
    {
      matcher: () => type === "antd",
      render: () => {
        return (
          <AntdBadge
            className={cx("py-1", className)}
            dot={dot}
            {...props}
          >
            {children || label}
          </AntdBadge>
        );
      },
    },
    {
      matcher: () => type === "filter",
      render: () => {
        return (
          <div
            className={cx(
              "py-1 px-2 flex-shrink-0 rounded-lg text-sm border border-gray-200 w-auto",
              isActive ? "text-primary border-primary bg-primary-20" : "text-gray-500",
              className
            )}
            {...props}
          >
            {children || label}
          </div>
        );
      },
    },
    {
      matcher: "default",
      render: () => {
        return (
          <div
            className={cx(
              "py-1 px-2 text-sm rounded-md",
              getTypeClasses(),
              className
            )}
            {...props}
          >
            {children || label}
          </div>
        );
      },
    }
  )(props);
};

export default Badge;
